import { Box, Text } from '@amzn/meridian';
import { useMemo } from 'react';
import { stylesheet } from 'typestyle';

/**
 * Styles for the pretty print container
 */
const css = stylesheet({
  prettyPrintContainer: {
    $nest: {
      '&>*': {
        fontFamily: `"Amazon Ember Monospace", Courier, monospace`,
        maxWidth: '100%',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      },
    },
    maxHeight: '25rem',
  },
});

/**
 * Component that renders a JSON object as formatted, pretty-printed text
 *
 * @param {Object} props - Component props
 * @param {unknown} props.objectToPrint - The object to stringify and display
 * @returns {React.ReactNode} Rendered component
 */
export const PrettyPrintJSON = ({ objectToPrint }: { objectToPrint: unknown }) => {
  /**
   * Converts the input object to a formatted JSON string
   * Uses 2-space indentation for readability
   */
  const contentString: string = useMemo(() => {
    if (!objectToPrint) return 'No content to show';
    return JSON.stringify(objectToPrint, null, 2);
  }, [
    objectToPrint,
  ]);
  return (
    <Box className={css.prettyPrintContainer} overflowY="auto" type="fill">
      <Text tag="pre" type="b200">
        {contentString}
      </Text>
    </Box>
  );
};
